import { useTranslation } from "react-i18next";
import cliente7Logo from "@/assets/logos/cliente7.png";
import cliente3Logo from "@/assets/logos/cliente3.png";
import cliente4Logo from "@/assets/logos/cliente4.png";
import cliente5Logo from "@/assets/logos/cliente5.png";
import cliente6Logo from "@/assets/logos/cliente6.png";
import cliente1Logo from "@/assets/logos/cliente1.png";

const logos = [
  { name: "Eleeva It", image: cliente7Logo },
  { name: "Kairos", image: cliente3Logo },
  { name: "Nextrion", image: cliente4Logo },
  { name: "Observability", image: cliente5Logo },
  { name: "Telyon", image: cliente6Logo },
  { name: "Vertice Insights", image: cliente1Logo },
];

const ClientLogos = () => {
  const { t } = useTranslation();

  return (
    <div>
      <p className="text-center text-sm font-medium text-muted-foreground mb-6">
        {t("results.logosTitle")}
      </p>
      <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto">
        {logos.map((logo) => (
          <li
            key={logo.name}
            className="flex items-center justify-center p-6 rounded-xl bg-card border border-border h-24"
          >
            <img
              src={logo.image}
              alt={`Logo ${logo.name}`}
              className="h-10 w-auto max-w-full object-contain grayscale"
              loading="lazy"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ClientLogos;
